export type Language = 'ro' | 'en';

type Dict = Record<string, string>;

export const TRANSLATIONS: Record<Language, Dict> = {
  ro: {
    // App / Nav
    'app.brand': 'TLS Portal',
    'app.brand.sub': 'Yang Ming · Romania',
    'nav.main': 'Principal',
    'nav.account': 'Cont',
    'nav.dashboard': 'Dashboard',
    'nav.containers': 'Containere',
    'nav.bills': 'Conosamente',
    'nav.invoices': 'Facturi',
    'nav.invoices.pill': 'În lucru',
    'nav.map': 'Hartă live',
    'nav.offers': 'Oferte',
    'nav.costs': 'Costuri',
    'nav.assistant': 'Asistent AI',
    'nav.assistant.pill': 'Beta',
    'nav.two_factor': 'Configurare 2FA',
    'nav.settings': 'Setări',
    'nav.logout': 'Deconectare',
    'nav.help': 'Ajutor',
    'nav.contact': 'Contact',
    'help.tour.replay': 'Reia turul ghidat',
    'nav.account_menu': 'Cont și securitate',
    'nav.profile': 'Setări profil',

    // Two-factor in-app page
    'sec.title': 'Securitate cont',
    'sec.subtitle': 'Activează autentificarea în doi factori pentru a-ți proteja contul.',
    'sec.status.active': 'Activă',
    'sec.status.inactive': 'Inactivă',

    // Header / Generic
    'header.search.placeholder': 'Caută containere, B/L-uri, oferte…',
    'common.all_companies': 'Toate firmele',
    'common.company': 'Firmă',
    'common.companies': 'Firme',
    'common.see_all': 'Vezi toate',
    'common.export': 'Export',
    'common.filter': 'Filtre',
    'common.sort': 'Sortare',
    'common.status': 'Status',
    'common.type': 'Tip',
    'common.route': 'Rută',
    'common.vessel': 'Navă',
    'common.voyage': 'Voyage',
    'common.eta': 'ETA',
    'common.etd': 'ETD',
    'common.commodity': 'Marfă',
    'common.pol': 'Port încărcare',
    'common.pod': 'Port descărcare',
    'common.weight': 'Greutate',
    'common.no_results': 'Niciun rezultat',
    'common.no_results.sub': 'Încearcă alte filtre sau termeni de căutare.',
    'common.close': 'Închide',
    'common.cancel': 'Anulează',
    'common.accept': 'Acceptă',
    'common.request_booking': 'Cere booking',
    'common.download': 'Descarcă',
    'common.transit': 'Tranzit',
    'common.days': 'zile',
    'common.day': 'zi',
    'common.from': 'din',
    'common.notifications': 'Notificări',
    'common.unread': 'necitite',
    'common.change_language': 'Schimbă limba',
    'common.toggle_theme': 'Schimbă tema',
    'common.toggle_sidebar': 'Comută sidebar',
    'common.open_menu': 'Deschide meniul',

    // Direcție transport (import / export)
    'direction.label': 'Direcție',
    'direction.import': 'Import',
    'direction.export': 'Export',
    'direction.switch': 'Schimbă direcția',

    // Statusuri export (booking-uri de export)
    // NOTĂ: etichetele de status NU se țin aici. Sursa unică e harta
    // `CONTAINER_STATUSES` din `features/dashboard/data/claudeMockData.ts`
    // (mecanism propriu labelRo/labelEn), cheiată pe id-urile UI trimise de
    // backend: booked | loaded | in_transit | transshipment | black_sea |
    // discharged | in_delivery | completed.

    // Dashboard
    'dash.welcome': 'Bună ziua',
    'dash.subtitle': 'Iată o privire de ansamblu asupra operațiunilor tale.',

    // Auth — Login
    'auth.brand.tagline.eyebrow': 'Constanța · România',
    'auth.brand.tagline.title': 'Containerele tale, vizibilitate completă.',
    'auth.brand.tagline.body': 'Urmărește expediții în timp real, gestionează documente și primește oferte directe de la linii.',
    'auth.brand.feature1.title': 'Tracking AIS live',
    'auth.brand.feature1.sub': 'Poziții și ETA actualizate la fiecare 24h',
    'auth.brand.feature2.title': 'Documente centralizate',
    'auth.brand.feature2.sub': 'Toate documentele expedițiilor tale, într-un singur loc',
    'auth.brand.feature3.title': 'Oferte personalizate',
    'auth.brand.feature3.sub': 'Cotații actualizate pentru rutele tale',
    'auth.brand.foot.terms': 'Termeni',
    'auth.brand.foot.privacy': 'Confidențialitate',
    'auth.brand.foot.status': 'Cookies',
    'auth.title.welcome': 'Bun venit înapoi',
    'auth.sub.welcome': 'Conectează-te pentru a gestiona expedițiile tale.',
    'auth.field.email': 'Email',
    'auth.field.password': 'Parolă',
    'auth.field.forgot': 'Ai uitat parola?',
    'auth.field.remember': 'Ține-mă conectat 30 zile pe acest dispozitiv',
    'auth.btn.signin': 'Conectează-te',
    'auth.btn.signin_loading': 'Se conectează…',
    'auth.divider.or': 'sau',
    'auth.btn.sso': 'Conectează-te cu SSO corporativ',
    'auth.foot.help.q': 'Probleme la autentificare?',
    'auth.foot.help.cta': 'Contactează echipa TLS',
    'auth.password.show': 'Afișează parola',
    'auth.password.hide': 'Ascunde parola',

    // 2FA — challenge
    'tfa.ch.title': 'Introdu codul din aplicație',
    'tfa.ch.title.email': 'Introdu codul primit pe email',
    'tfa.ch.sub.app': 'Deschide aplicația de autentificare și introdu codul de 6 cifre asociat contului.',
    'tfa.ch.sub.email': 'Am trimis un cod de 6 cifre pe emailul tău. Verifică inbox-ul și spam-ul.',
    'tfa.ch.trust': 'Ai încredere în acest dispozitiv 30 de zile',
    'tfa.ch.btn.verify': 'Verifică și intră în portal',
    'tfa.ch.btn.verifying': 'Se verifică…',
    'tfa.ch.back': 'Înapoi',
    'tfa.ch.backup_cta': 'Folosește un cod de rezervă',
    'tfa.ch.refresh_30': 'Codul se schimbă la fiecare 30s',
    'tfa.ch.refresh_email': 'Codul expiră în câteva minute',
    'tfa.ch.help_q': 'Nu ai acces la aplicație?',
    'tfa.ch.help_cta': 'Contactează suportul',
    'tfa.err.all_digits': 'Introdu toate cele 6 cifre',
    'tfa.subtitle_short': 'Verificare în 2 pași',

    // 2FA — setup (in-app)
    'tfa.steps.choose': 'Alege metoda',
    'tfa.steps.setup': 'Configurare',
    'tfa.steps.verify': 'Verifică',
    'tfa.steps.done': 'Gata',
    'tfa.choose.title': 'Activează autentificarea în 2 pași',
    'tfa.choose.sub': 'Adaugă un strat suplimentar de protecție pentru contul tău TLS. Va fi necesar un cod la fiecare autentificare.',
    'tfa.choose.app.title': 'Aplicație de autentificare',
    'tfa.choose.app.sub': 'Folosește Google Authenticator, Authy sau 1Password pentru a genera coduri locale, fără internet.',
    'tfa.choose.email.title': 'Email',
    'tfa.choose.email.sub': 'Primești codul de verificare pe email la fiecare autentificare. Mai puțin sigur decât o aplicație.',
    'tfa.choose.recommended': 'Recomandat',
    'tfa.choose.info': 'Vei putea schimba metoda oricând din setările contului.',
    'tfa.app.title': 'Scanează codul QR',
    'tfa.app.sub': 'Deschide aplicația de autentificare și scanează codul de mai jos. Alternativ, introdu cheia manual.',
    'tfa.app.manual_label': 'Sau introdu manual cheia:',
    'tfa.app.copy': 'Copiază',
    'tfa.app.copied': 'Copiat',
    'tfa.app.continue': 'Am scanat codul, continuă',
    'tfa.app.refresh_30': 'Cod valabil 30 secunde',
    'tfa.email.title': 'Verificare prin email',
    'tfa.email.sub': 'Vom trimite un cod de 6 cifre la adresa de mai jos. Codul expiră în 10 minute.',
    'tfa.email.label': 'Codul va fi trimis la:',
    'tfa.email.change': 'Schimbă',
    'tfa.email.send': 'Trimite codul de verificare',
    'tfa.email.sending': 'Se trimite…',
    'tfa.verify.title': 'Introdu codul de verificare',
    'tfa.verify.sub.app': 'Introdu codul curent din aplicația ta de autentificare.',
    'tfa.verify.sub.email': 'Am trimis un cod de 6 cifre pe email. Verifică inbox-ul și spam-ul.',
    'tfa.verify.btn': 'Verifică și activează',
    'tfa.verify.btn_loading': 'Se verifică…',
    'tfa.verify.resend_in': 'Poți retrimite codul în {s}s',
    'tfa.verify.resend': 'Retrimite codul',
    'tfa.verify.app_30': 'Codul se schimbă la fiecare 30 secunde în aplicație.',
    'tfa.done.title.app': 'Autentificare în 2 pași activă',
    'tfa.done.sub.app': 'De acum, la fiecare autentificare vei avea nevoie de un cod din aplicație.',
    'tfa.done.sub.email': 'De acum, la fiecare autentificare vei primi un cod pe email.',
    'tfa.done.go': 'Mergi la portal',
    'tfa.backup.title': 'Coduri de rezervă',
    'tfa.backup.sub': 'Salvează aceste 10 coduri într-un loc sigur. Fiecare poate fi folosit o singură dată dacă pierzi accesul la metoda principală.',
    'tfa.backup.copy_all': 'Copiază toate',
    'tfa.backup.download': 'Descarcă .txt',

    'ai.title': 'Asistent AI',
    'ai.subtitle': 'Întreabă orice despre containere, B/L-uri, oferte sau operațiuni.',
    'ai.new': 'Conversație nouă',
    'ai.search': 'Caută conversații',
    'ai.empty.title': 'Cu ce te pot ajuta azi?',
    'ai.empty.sub': 'Pune o întrebare sau alege o sugestie de mai jos.',
    'ai.input.placeholder': 'Scrie un mesaj…',
    'ai.send': 'Trimite',
    'ai.attach': 'Atașează fișier',
    'ai.thinking': 'Asistentul scrie…',
    'ai.you': 'Tu',
    'ai.assistant': 'Asistent',
    'ai.today': 'Astăzi',
    'ai.yesterday': 'Ieri',
    'ai.week': 'Săptămâna aceasta',
    'ai.older': 'Mai vechi',
    'ai.pinned': 'Fixate',
    'ai.empty_conv': 'Conversație goală',
    'ai.suggest.title': 'Sugestii rapide',
    'ai.s1': 'Ce containere sosesc săptămâna aceasta?',
    'ai.s2': 'Status booking recent',
    'ai.s3': 'Câte containere am în tranzit?',
    'ai.s4': 'Sumarizează ultimul B/L emis',
    'ai.rename': 'Redenumește',
    'ai.rename.title': 'Redenumește conversația',
    'ai.rename.sub': 'Alege un nume scurt și descriptiv.',
    'ai.rename.label': 'Nume',
    'ai.rename.placeholder': 'ex: Rute Asia → Constanța',
    'ai.rename.save': 'Salvează',
    'ai.delete': 'Șterge',
    'ai.delete.confirm': 'Ștergi această conversație?',
    'ai.pin': 'Fixează',
    'ai.unpin': 'Anulează fixarea',
    'ai.shortcut.hint': 'Enter pentru a trimite, Shift+Enter pentru rând nou',
    'ai.powered': 'Asistent intern · alimentat de Mistral AI',
    'ai.messages': 'mesaje',
    'ai.disclaimer': 'Asistentul poate face greșeli. Verifică informațiile importante.',
    'common.no_results.simple': 'Niciun rezultat',

    'help.subtitle': 'Contactează echipa TLS pentru asistență operațională.',
    'help.sales.title': 'Agentul tău de vânzări',
    'help.sales.sub': 'Persoana atribuită primei firme din contul tău.',
    'help.sales.name': 'Nume',
    'help.sales.email': 'Email',
    'help.sales.phone': 'Telefon',
    'help.sales.client': 'Firma',
    'help.sales.empty.title': 'Niciun sales atribuit',
    'help.sales.empty.sub': 'Folosește contactul general de mai jos sau scrie-ne pe email.',
    'help.general.title': 'Contact general TLS',
    'help.general.sub': 'Pentru cereri generale sau dacă sales-ul tău nu este disponibil.',

    'map.title': 'Hartă live',
    'map.subtitle': 'Poziții live ale navelor și containerelor tale în terminale.',
    'map.tracks': 'În tranzit acum',
    'map.tracks.empty': 'Nicio navă sau port cu containere active.',
    'map.legend.your_ship': 'Nava ta',
    'map.legend.port': 'Port',
    'map.legend.transit': 'Containere în port',
    'map.refresh': 'Reîmprospătează',
    'map.loading': 'Se încarcă harta…',
  },

  en: {
    'app.brand': 'TLS Portal',
    'app.brand.sub': 'Yang Ming · Romania',
    'nav.main': 'Main',
    'nav.account': 'Account',
    'nav.dashboard': 'Dashboard',
    'nav.containers': 'Containers',
    'nav.bills': 'Bills of Lading',
    'nav.invoices': 'Invoices',
    'nav.invoices.pill': 'Coming soon',
    'nav.map': 'Live map',
    'nav.offers': 'Offers',
    'nav.costs': 'Costs',
    'nav.assistant': 'AI Assistant',
    'nav.assistant.pill': 'Beta',
    'nav.two_factor': '2FA setup',
    'nav.settings': 'Settings',
    'nav.logout': 'Sign out',
    'nav.help': 'Help',
    'nav.contact': 'Contact',
    'help.tour.replay': 'Replay the guided tour',
    'nav.account_menu': 'Account & security',
    'nav.profile': 'Profile settings',

    'sec.title': 'Account security',
    'sec.subtitle': 'Turn on two-factor authentication to protect your account.',
    'sec.status.active': 'Active',
    'sec.status.inactive': 'Inactive',

    'header.search.placeholder': 'Search containers, B/Ls, offers…',
    'common.all_companies': 'All companies',
    'common.company': 'Company',
    'common.companies': 'Companies',
    'common.see_all': 'View all',
    'common.export': 'Export',
    'common.filter': 'Filters',
    'common.sort': 'Sort',
    'common.status': 'Status',
    'common.type': 'Type',
    'common.route': 'Route',
    'common.vessel': 'Vessel',
    'common.voyage': 'Voyage',
    'common.eta': 'ETA',
    'common.etd': 'ETD',
    'common.commodity': 'Commodity',
    'common.pol': 'Port of loading',
    'common.pod': 'Port of discharge',
    'common.weight': 'Weight',
    'common.no_results': 'No results',
    'common.no_results.sub': 'Try different filters or search terms.',
    'common.close': 'Close',
    'common.cancel': 'Cancel',
    'common.accept': 'Accept',
    'common.request_booking': 'Request booking',
    'common.download': 'Download',
    'common.transit': 'Transit',
    'common.days': 'days',
    'common.day': 'day',
    'common.from': 'from',
    'common.notifications': 'Notifications',
    'common.unread': 'unread',
    'common.change_language': 'Change language',
    'common.toggle_theme': 'Toggle theme',
    'common.toggle_sidebar': 'Toggle sidebar',
    'common.open_menu': 'Open menu',

    // Shipping direction (import / export)
    'direction.label': 'Direction',
    'direction.import': 'Import',
    'direction.export': 'Export',
    'direction.switch': 'Change direction',

    // Export statuses (export bookings)
    // NOTE: status labels are not kept here — see the Romanian block above.

    'dash.welcome': 'Good day',
    'dash.subtitle': "Here's an overview of your operations.",

    // Auth — Login
    'auth.brand.tagline.eyebrow': 'Constanța · Romania',
    'auth.brand.tagline.title': 'Your containers, full visibility.',
    'auth.brand.tagline.body': 'Track shipments live, manage documents, and get carrier-direct offers.',
    'auth.brand.feature1.title': 'Live AIS tracking',
    'auth.brand.feature1.sub': 'Positions and ETA refreshed every 24h',
    'auth.brand.feature2.title': 'Centralized documents',
    'auth.brand.feature2.sub': 'All your shipment documents in one place',
    'auth.brand.feature3.title': 'Personalized offers',
    'auth.brand.feature3.sub': 'Up-to-date quotes for your routes',
    'auth.brand.foot.terms': 'Terms',
    'auth.brand.foot.privacy': 'Privacy',
    'auth.brand.foot.status': 'Cookies',
    'auth.title.welcome': 'Welcome back',
    'auth.sub.welcome': 'Sign in to manage your shipments.',
    'auth.field.email': 'Email',
    'auth.field.password': 'Password',
    'auth.field.forgot': 'Forgot password?',
    'auth.field.remember': 'Keep me signed in for 30 days on this device',
    'auth.btn.signin': 'Sign in',
    'auth.btn.signin_loading': 'Signing in…',
    'auth.divider.or': 'or',
    'auth.btn.sso': 'Continue with corporate SSO',
    'auth.foot.help.q': 'Trouble signing in?',
    'auth.foot.help.cta': 'Contact the TLS team',
    'auth.password.show': 'Show password',
    'auth.password.hide': 'Hide password',

    // 2FA — challenge
    'tfa.ch.title': 'Enter your authenticator code',
    'tfa.ch.title.email': 'Enter the code sent to your email',
    'tfa.ch.sub.app': 'Open your authenticator app and enter the 6-digit code for your account.',
    'tfa.ch.sub.email': "We've sent a 6-digit code to your email. Check inbox and spam.",
    'tfa.ch.trust': 'Trust this device for 30 days',
    'tfa.ch.btn.verify': 'Verify and continue',
    'tfa.ch.btn.verifying': 'Verifying…',
    'tfa.ch.back': 'Back',
    'tfa.ch.backup_cta': 'Use a backup code',
    'tfa.ch.refresh_30': 'Code refreshes every 30s',
    'tfa.ch.refresh_email': 'Code expires in a few minutes',
    'tfa.ch.help_q': "Can't access your app?",
    'tfa.ch.help_cta': 'Contact support',
    'tfa.err.all_digits': 'Enter all 6 digits',
    'tfa.subtitle_short': 'Two-step verification',

    // 2FA — setup (in-app)
    'tfa.steps.choose': 'Choose method',
    'tfa.steps.setup': 'Configure',
    'tfa.steps.verify': 'Verify',
    'tfa.steps.done': 'Done',
    'tfa.choose.title': 'Set up two-factor authentication',
    'tfa.choose.sub': 'Add an extra layer of protection to your TLS account. A verification code will be required at each sign-in.',
    'tfa.choose.app.title': 'Authenticator app',
    'tfa.choose.app.sub': 'Use Google Authenticator, Authy or 1Password to generate codes locally, offline.',
    'tfa.choose.email.title': 'Email',
    'tfa.choose.email.sub': 'Receive the verification code by email at each sign-in. Less secure than an app.',
    'tfa.choose.recommended': 'Recommended',
    'tfa.choose.info': 'You can change the method anytime from your account settings.',
    'tfa.app.title': 'Scan the QR code',
    'tfa.app.sub': 'Open your authenticator app and scan the code below. Or enter the key manually.',
    'tfa.app.manual_label': 'Or enter the key manually:',
    'tfa.app.copy': 'Copy',
    'tfa.app.copied': 'Copied',
    'tfa.app.continue': "I've scanned the code, continue",
    'tfa.app.refresh_30': 'Code refreshes every 30s',
    'tfa.email.title': 'Email verification',
    'tfa.email.sub': "We'll send a 6-digit code to the address below. The code expires in 10 minutes.",
    'tfa.email.label': 'Code will be sent to:',
    'tfa.email.change': 'Change',
    'tfa.email.send': 'Send verification code',
    'tfa.email.sending': 'Sending…',
    'tfa.verify.title': 'Enter the verification code',
    'tfa.verify.sub.app': 'Enter the current code from your authenticator app.',
    'tfa.verify.sub.email': "We've sent a 6-digit code to your email. Check inbox and spam.",
    'tfa.verify.btn': 'Verify and activate',
    'tfa.verify.btn_loading': 'Verifying…',
    'tfa.verify.resend_in': 'You can resend the code in {s}s',
    'tfa.verify.resend': 'Resend code',
    'tfa.verify.app_30': 'The code changes every 30 seconds in the app.',
    'tfa.done.title.app': 'Two-factor is now active',
    'tfa.done.sub.app': 'From now on, each sign-in will require a code from your authenticator app.',
    'tfa.done.sub.email': 'From now on, each sign-in will require a code sent to your email.',
    'tfa.done.go': 'Go to portal',
    'tfa.backup.title': 'Backup codes',
    'tfa.backup.sub': 'Save these 10 codes in a safe place. Each one can be used once if you lose access to your primary method.',
    'tfa.backup.copy_all': 'Copy all',
    'tfa.backup.download': 'Download .txt',

    'ai.title': 'AI Assistant',
    'ai.subtitle': 'Ask anything about containers, B/Ls, offers or operations.',
    'ai.new': 'New conversation',
    'ai.search': 'Search conversations',
    'ai.empty.title': 'How can I help you today?',
    'ai.empty.sub': 'Ask a question or pick a suggestion below.',
    'ai.input.placeholder': 'Type a message…',
    'ai.send': 'Send',
    'ai.attach': 'Attach file',
    'ai.thinking': 'Assistant is typing…',
    'ai.you': 'You',
    'ai.assistant': 'Assistant',
    'ai.today': 'Today',
    'ai.yesterday': 'Yesterday',
    'ai.week': 'This week',
    'ai.older': 'Older',
    'ai.pinned': 'Pinned',
    'ai.empty_conv': 'Empty conversation',
    'ai.suggest.title': 'Quick suggestions',
    'ai.s1': 'Which containers are arriving this week?',
    'ai.s2': 'Recent booking status',
    'ai.s3': 'How many containers do I have in transit?',
    'ai.s4': 'Summarize the latest B/L issued',
    'ai.rename': 'Rename',
    'ai.rename.title': 'Rename conversation',
    'ai.rename.sub': 'Pick a short, descriptive name.',
    'ai.rename.label': 'Name',
    'ai.rename.placeholder': 'e.g. Asia → Constanța lanes',
    'ai.rename.save': 'Save',
    'ai.delete': 'Delete',
    'ai.delete.confirm': 'Delete this conversation?',
    'ai.pin': 'Pin',
    'ai.unpin': 'Unpin',
    'ai.shortcut.hint': 'Enter to send, Shift+Enter for new line',
    'ai.powered': 'Internal assistant · powered by Claude',
    'ai.messages': 'messages',
    'ai.disclaimer': 'The assistant can make mistakes. Verify important information.',
    'common.no_results.simple': 'No results',

    'help.subtitle': 'Reach out to the TLS team for operational support.',
    'help.sales.title': 'Your sales contact',
    'help.sales.sub': 'The person assigned to the first company in your account.',
    'help.sales.name': 'Name',
    'help.sales.email': 'Email',
    'help.sales.phone': 'Phone',
    'help.sales.client': 'Company',
    'help.sales.empty.title': 'No sales assigned',
    'help.sales.empty.sub': 'Use the general contact below or email us.',
    'help.general.title': 'General TLS contact',
    'help.general.sub': 'For general requests or when your sales rep is unavailable.',

    'map.title': 'Live map',
    'map.subtitle': 'Real-time positions of vessels and your containers in terminals.',
    'map.tracks': 'In transit now',
    'map.tracks.empty': 'No vessels or ports with active containers.',
    'map.legend.your_ship': 'Your vessel',
    'map.legend.port': 'Port',
    'map.legend.transit': 'Containers in port',
    'map.refresh': 'Refresh',
    'map.loading': 'Loading map…',
  },
};
